$(document).ready(function() {
  //  $(".topcolseawwefdfg").css("display", "none")
    $(window).scroll(function() {
             

        var o = $(window).scrollTop();
        if (o > 60) {
            $(".header-wrapper").css("position", "fixed");
            $(".header-wrapper").css("width", "100%");
            $(".header-wrapper").css("top", "0px")
            // $(".topcolseawwefdfg").css("display", "block")
            // $(".top-menu-new-searchgvdffdf").css("display", "none")
          
        } else {
             $(".header-wrapper").css("position", "inherit");
            $(".header-wrapper").css("top", "")
            // $(".top-menu-new-searchgvdffdf").css("display", "block")
              // $(".topcolseawwefdfg").css("display", "none")
        }
    })
});








document.addEventListener("DOMContentLoaded", function () {

  new Swiper(".certificate-slide", {
    loop: true,
    speed: 1300, // smooth animation
    slidesPerView: 12,
    spaceBetween: 10,

    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },

    breakpoints: {
      1440: {
        slidesPerView: 10,
      },
      1200: {
        slidesPerView: 8,
      },
      600: {
        slidesPerView: 6,
      },
      0: {
        slidesPerView: 4,
        spaceBetween: 10,
      }
    },

    navigation: false,
    pagination: false,
  });






  new Swiper('.two-link-slide', {
      loop: false, // loop off
      speed: 700,
      slidesPerView: 1,
      spaceBetween: 0,
    pagination: {
  el: '.swiper-pagination',
  clickable: true,
},
      autoplay: true, // autoplay off
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        1440: {
          slidesPerView: 1,
        },
     
        1200: {
          slidesPerView: 1,
        },
        600: {
          slidesPerView: 1,
        },
        0: {
          slidesPerView: 1, // Mobile default
          
        }
      }
    });




    new Swiper('.many-tab-slider', {
  loop: true,
  speed: 700,
  slidesPerView: 4,
  spaceBetween: 0,

  autoplay: false,

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  breakpoints: {
    1440: { slidesPerView: 4 },
    1200: { slidesPerView: 4 },
    600: { slidesPerView: 1.5 },
    0:   { slidesPerView: 1 },
  }
});





  var swiper = new Swiper(".brandSwiper", {
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    speed: 900, /* smooth sliding */
    slidesPerView: 1,
  });




 const swiperEl = document.querySelector('.oneImageSwiper');
  if (!swiperEl) return;

  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

  const swipers = new Swiper('.oneImageSwiper', {
    loop: slideCount > 1,
    autoplay: false,
    speed: 700,

    // Desktop Navigation
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // Mobile Pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    // Breakpoints
    breakpoints: {
      768: {
        pagination: false,   // 👈 Desktop: NO dots
      }
    }
  });

  // Hide arrows if slides = 1
  if (slideCount <= 1) {
    swiperEl.querySelector('.swiper-button-next').style.display = 'none';
    swiperEl.querySelector('.swiper-button-prev').style.display = 'none';
  }


  
 const swiperEls = document.querySelector('.oneImageSwipers');
  if (!swiperEls) return;

  const slideCounts = swiperEls.querySelectorAll('.swiper-slide').length;

  const swiperss = new Swiper('.oneImageSwipers', {
    loop: slideCounts > 1,
    autoplay: false,
    speed: 700,

    // Desktop Navigation
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // Mobile Pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    // Breakpoints
    breakpoints: {
      768: {
        pagination: false,   // 👈 Desktop: NO dots
      }
    }
  });

  // Hide arrows if slides = 1
  if (slideCounts <= 1) {
    swiperEls.querySelector('.swiper-button-next').style.display = 'none';
    swiperEls.querySelector('.swiper-button-prev').style.display = 'none';
  }







  
  });




document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.variant-slider-wrapper').forEach(wrapper => {
    const track = wrapper.querySelector('.variant-slider-track');
    const prevBtn = wrapper.querySelector('.variant-nav.prev');
    const nextBtn = wrapper.querySelector('.variant-nav.next');

    const slideWidth = 220;

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: slideWidth, behavior: 'smooth' });
    });

    const updateButtons = () => {
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled =
        track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    };

    track.addEventListener('scroll', updateButtons);
    updateButtons();
  });
});

/* Scroll selected variant into view */
document.addEventListener('change', e => {
  if (!e.target.matches('.variant-slider-track input[type="radio"]')) return;

  const label = e.target.nextElementSibling;
  label?.scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest'
  });
});


